import React from 'react';

export const AlignLinkLogo = () => (
  <svg
    width="192"
    height="50"
    viewBox="0 0 192 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M138.363 12.3852H141.416V37.9276H138.363V12.3852Z"
      fill="#009ACE"
    />
    <path
      d="M139.889 9.12424C138.907 9.12424 138.108 8.32276 138.108 7.33776C138.108 6.35276 138.907 5.55127 139.889 5.55127C140.871 5.55127 141.669 6.35276 141.669 7.33776C141.669 8.32276 140.871 9.12424 139.889 9.12424Z"
      fill="#009ACE"
    />
    <path
      d="M129.895 2.61687H132.946V37.9194H129.895V2.61687Z"
      fill="#009ACE"
    />
    <path
      d="M146.528 12.3929H149.579V16.2936H149.677C151.4 13.7259 154.156 11.8496 158.19 11.8496C162.915 11.8496 166.31 14.6642 166.31 19.7989V37.9193H163.259V20.0952C163.259 16.2442 161.045 14.4667 157.453 14.4667C153.122 14.4667 149.579 17.5279 149.579 21.7245V37.9193H146.528V12.3929Z"
      fill="#009ACE"
    />
    <path
      d="M171.233 2.61687H174.284V24.6871L186.931 12.393H190.819L181.075 21.6259L192 37.9194H188.457L178.959 23.6009L174.284 28.0939V37.9194H171.233V2.61687Z"
      fill="#009ACE"
    />
    <path
      d="M88.077 12.3749H93.7428L93.8337 14.7422C94.3528 14.0872 96.4928 11.6609 100.34 11.6609C106.562 11.6609 109.959 15.5206 109.959 22.2469V37.9273H104.08V22.4402C104.08 18.9776 101.972 16.9916 99.013 16.9916C96.0756 16.9916 93.9567 18.9776 93.9567 22.4402V37.9273H88.077V12.3749ZM38.4527 37.9273H32.5674V0.785136H38.4527V37.9273ZM51.026 37.9273H45.1405V12.3749H51.026V37.9273ZM20.0691 12.3749H25.8902V37.9273H20.0691L19.9781 35.2486C18.9081 36.3436 16.0617 38.6466 12.0863 38.6466C5.14698 38.6466 0 33.0421 0 25.151C0 16.8036 5.56966 11.6609 12.0863 11.6609C16.6501 11.6609 19.2182 14.1463 19.9781 15.0643L20.0691 12.3749ZM6.01371 25.151C6.01371 30.0521 9.01002 33.3214 13.1725 33.3214C16.9498 33.3214 20.3419 30.5622 20.3419 25.151C20.3419 19.8956 17.0889 16.9808 13.1725 16.9808C8.83881 16.9808 6.01371 20.4486 6.01371 25.151ZM75.8408 25.151C75.8408 19.8206 72.4914 16.9808 68.6872 16.9808C64.1341 16.9808 61.5126 20.6954 61.5126 25.151C61.5126 29.8536 64.3374 33.3214 68.682 33.3214C72.6787 33.3214 75.8408 30.3365 75.8408 25.151ZM81.3836 35.3987C81.3836 46.3605 74.9899 50 67.4622 50C62.4434 50 59.4153 48.4809 58.3505 47.9763L59.8112 42.8982C60.4746 43.247 63.2247 44.8843 67.414 44.8843C71.7958 44.8843 75.5091 42.066 75.5091 36.9931V35.2269C75.0327 35.7263 72.5448 38.6466 67.5531 38.6466C60.694 38.6466 55.5096 33.1119 55.5096 25.151C55.5096 17.5228 60.3889 11.6609 67.5745 11.6609C72.4755 11.6609 74.9634 14.4522 75.477 15.0643L75.5518 12.3749H81.3836V35.3987Z"
      fill="#3D3935"
    />
    <path
      d="M110.775 12.1847H114.066V12.8352H112.796V16.2514H112.039V12.8352H110.775V12.1847Z"
      fill="#3D3935"
    />
    <path
      d="M114.607 12.1847H115.603L116.268 14.1198C116.426 14.5954 116.623 15.4863 116.623 15.4863H116.638C116.638 15.4863 116.834 14.6006 116.987 14.1198L117.641 12.1847H118.66V16.2514H117.957V14.1309C117.957 13.6881 118.006 12.8627 118.006 12.8627H117.995C117.995 12.8627 117.827 13.6115 117.695 14.0156L116.927 16.2514H116.317L115.544 14.0156C115.412 13.6115 115.244 12.8627 115.244 12.8627H115.233C115.233 12.8627 115.282 13.6881 115.282 14.1309V16.2514H114.607V12.1847Z"
      fill="#3D3935"
    />
    <path
      d="M48.08 0C46.042 0 44.3998 1.65841 44.3998 3.70347C44.3998 5.73754 46.042 7.40145 48.08 7.40145C50.1128 7.40145 51.7712 5.73754 51.7712 3.70347C51.7712 1.65841 50.1128 0 48.08 0Z"
      fill="#009ACE"
    />
  </svg>
);
